import src from "IMAGE";
export default { src, width: 2400, height: 1602, blurWidth: 0, blurHeight: 0};
